import React, { useEffect, useState } from "react";
import { Tree } from "primereact/tree";
import { useParams } from "react-router-dom";
import * as enums from "../../../common/enum";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";
import {
  GET_AREA_EVENT,
  DETAIL_EVENT,
  GET_LIST_AREA,
  GET_EVENT_LIST_IMAGE,
  GET_CHANNELS,
  GET_IMAGES_EVENTS,
  GET_CHANNELS_PACKAGE,
  GET_PACKAGE_IMAGES_EVENTID,
  // LIST_EVENT,
} from "../../../store/constants/serviceEndpoint";
/*Cài đặt hoạt động*/
import DetailEvent from "./DetailEvent";
/*Cài đặt vùng*/
import ConfigArea from "./ConfigArea";
import TargetArea from "./ConfigTargetWithArea";
import ConfigImage from "./ConfigImage";
import ConfigChanel from "./ConfigChannel";
import ImageWithChannel from "./ImageWithChannel";
import ConfigChannelPackage from "./ConfigChannelPackage";
import ConfigChannelPackageImage from "./ConfigChannelPackageImage";
// import ImageProduct from "./ImageProduct";
// import ListImageProduct from "../imageproduct";
import _ from "lodash";

const listDataTree = [
  {
    key: -1,
    label: "Thông tin hoạt động",
    expanded: true,
    children: [
      {
        key: 1,
        label: "Cài đặt hoạt động",
      },
    ],
  },
  {
    key: -2,
    label: "Thông tin vùng diễn ra hoạt động",
    expanded: true,
    children: [
      {
        key: 2,
        label: "Cài đặt vùng",
      },
      {
        key: 9,
        label: "Cài đặt chỉ tiêu theo vùng",
      },
    ],
  },
  {
    key: -5,
    label: "Thông tin hình",
    expanded: true,
    children: [
      {
        key: 5,
        label: "Cài đặt hình",
      },
    ],
  },
  {
    key: -3,
    label: "Thông tin kênh",
    expanded: true,
    children: [
      {
        key: 3,
        label: "Cài đặt kênh",
      },
      {
        key: 4,
        label: "Cài đặt hình theo kênh",
      },
    ],
  },
  {
    key: -4,
    label: "Thông tin suất",
    expanded: true,
    children: [
      {
        key: 6,
        label: "Cài đặt suất",
      },
      {
        key: 7,
        label: "Cài đặt hình theo suất",
      },
    ],
  },
  // {
  //   key: -6,
  //   label: "Hình ảnh theo sản phẩm",
  //   expanded: true,
  //   children: [
  //     {
  //       key: 8,
  //       label: "Cài đặt hình",
  //     },
  //   ],
  // },
];

const expandedKeys = {
  "-1": true,
  "-2": true,
  "-3": true,
  "-4": true,
  "-5": true,
  "-6": true,
};

const multiGroupBy = (array, group, ...restGroups) => {
  if (!group) {
    return array;
  }
  const currGrouping = _.groupBy(array, group);
  if (!restGroups.length) {
    return currGrouping;
  }
  return _.transform(
    currGrouping,
    (result, value, key) => {
      result[key] = multiGroupBy(value, ...restGroups);
    },
    {}
  );
};

export default function UpdateEvent() {
  const { eventId } = useParams();
  const [selectedNode, setSelectedNode] = useState(1);
  const [loadingArea, setLoadingArea] = useState(false);
  const [loadingAreaSelect, setLoadingAreaSelect] = useState(false);
  const [listArea, setListArea] = useState([]);
  const [listAreaSelected, setListAreaSelected] = useState([]);

  const [targetArea, setTargetArea] = useState([]);
  const [loadingEvent, setLoadingEvent] = useState(false);
  const [event, setEvent] = useState(null);

  const [loadingImageEvent, setLoadingImageEvent] = useState(false);
  const [listImage, setListImage] = useState([]);

  const [loadingChannelEvent, setLoadingChannelEvent] = useState(false);
  const [listChannel, setListChannel] = useState([]);

  const [loadingImageChannel, setLoadingImageChannel] = useState(false);
  const [listImageChannel, setListImageChannel] = useState([]);

  const [loadingChannelPackage, setLoadingChannelPackage] = useState(false);
  const [listChannelPackage, setListChannelPackage] = useState([]);

  const [loadingImageChannelPackage, setLoadingImageChannelPackage] =
    useState(false);
  const [listImageChannelPackage, setListImageChannelPackage] = useState([]);

  // const [loadingListEvent, setLoadingListEvent] = useState(false);
  // const [listEvent, setListEvent] = useState([]);

  // const [loadingProduct, setLoadingProduct] = useState(false);
  // const [listProduct, setListProduct] = useState([]);
  
  // const [loadingEventProduct, setLoadingEventProduct] = useState(false);
  // const [dataImageProduct, setDataImageProduct] = useState([]);

  // console.log(param);
  const getListArea = async () => {
    setLoadingArea(true);
    await axiosWithHeaders("get", GET_LIST_AREA, null)
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            let arr = [];
            result.forEach((item) => {
              let obj = {};
              obj["value"] = item.id;
              obj["label"] = item.name;
              arr.push(obj);
            });
            setListArea(arr);
          } else {
            alert(message);
          }
        }
      })
      .catch((err) => alert(err.toString()))
      .finally(() => setLoadingArea(false));
  };

  const getDetailEvent = async (eventId) => {
    setLoadingEvent(true);
    await axiosWithHeaders("get", DETAIL_EVENT, { Id: eventId })
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            setEvent(result);
          } else {
            alert(message);
          }
        }
      })
      .catch((err) => alert(err.toString()))
      .finally(() => {
        setLoadingEvent(false);
      });
  };

  const getListAreaEvent = async (eventId) => {
    setLoadingAreaSelect(true);
    await axiosWithHeaders("get", GET_AREA_EVENT, { id: eventId })
      .then(function (response) {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            let arr = [];
            result.forEach((item) => {
              let obj = {};
              obj["value"] = item.areaId;
              obj["id"] = item.id;
              obj["label"] = item.areaName;
              arr.push(obj);
            });
            setListAreaSelected(arr);
            setTargetArea(result);
          } else {
            alert(message);
          }
        }
      })
      .catch((err) => alert(err.toString()))
      .finally(() => {
        setLoadingAreaSelect(false);
      });
  };

  const getImageByEvent = async (eventId) => {
    setLoadingImageEvent(true);
    await axiosWithHeaders("get", GET_EVENT_LIST_IMAGE, { id: eventId })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            setListImage(result);
          } else {
            alert(message);
          }
        }
      })
      .catch((error) => alert(error.toString()))
      .finally(() => {
        setLoadingImageEvent(false);
      });
  };

  const getChanelByEvent = async (eventId) => {
    setLoadingChannelEvent(true);
    axiosWithHeaders("get", GET_CHANNELS, { id: eventId })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            setListChannel(result);
          } else {
            alert(message);
          }
        }
      })
      .catch((error) => alert(error.toString()))
      .finally(() => {
        setLoadingChannelEvent(false);
      });
  };

  const getChannelImageByEvent = async (eventId) => {
    setLoadingImageChannel(true);
    axiosWithHeaders("post", GET_IMAGES_EVENTS, { eventId })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            setListImageChannel(result);
          } else {
            alert(message);
          }
          // console.log(result);
        }
      })
      .catch((error) => alert(error.toString()))
      .finally(() => {
        setLoadingImageChannel(false);
      });
  };

  const getPackageImageEventId = async (eventId) => {
    setLoadingImageChannelPackage(true);
    axiosWithHeaders("get", GET_PACKAGE_IMAGES_EVENTID, { eventId })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { result, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            const datas = multiGroupBy(result, "channelName");
            let arr = [];
            for (var field in datas) {
              let obj = {};
              obj["channelName"] = field;
              obj["dataPackage"] = datas[field];
              arr.push(obj);
            }

            setListImageChannelPackage(arr);
          } else {
            alert(message);
          }
          console.log(response.data);
          // console.log(result);
        }
      })
      .catch((error) => alert(error.toString()))
      .finally(() => {
        setLoadingImageChannelPackage(false);
      });
  };

  const getChannelPackage = async (id) => {
    setLoadingChannelPackage(true);
    axiosWithHeaders("get", GET_CHANNELS_PACKAGE, { id })
      .then((response) => {
        // console.log(response);
        if (
          response &&
          response.data &&
          response.status === enums.RESPONSE_OK
        ) {
          const { data, status, message } = response.data;
          if (status === enums.RESPONSE_OK) {
            setListChannelPackage(data);
          } else {
            alert(message);
          }
        }
      })
      .catch((error) => alert(error.toString()))
      .finally(() => {
        setLoadingChannelPackage(false);
      });
  };

  // const getListEvent = async () => {
  //   setLoadingListEvent(true);
  //   axiosWithHeaders("post", LIST_EVENT, null)
  //     .then((response) => {
  //       console.log(response);
  //     })
  //     .catch((error) => alert(error.toString()))
  //     .finally(() => {
  //       setLoadingListEvent(false);
  //     });
  // }

  useEffect(() => {
    getListArea();
    // getListEvent();
  }, []);

  // console.log(listArea);

  useEffect(() => {
    getDetailEvent(eventId);
    getListAreaEvent(eventId);
    getImageByEvent(eventId);
    getChanelByEvent(eventId);
    getChannelImageByEvent(eventId);
    getChannelPackage(eventId);
    getPackageImageEventId(eventId);
    //eslint-disable-next-line
  }, [eventId]);

  const LoadingComponent = () => {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: 500 }}
      >
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="ml-3">Đang tải dữ liệu...</div>
      </div>
    );
  };

  const renderBody = () => {
    // if(loadingArea || loadingEvent){
    //   return (

    //   )
    // }
    if (
      loadingEvent ||
      loadingArea ||
      loadingAreaSelect ||
      loadingImageEvent ||
      loadingChannelEvent ||
      loadingImageChannel ||
      loadingChannelPackage ||
      loadingImageChannelPackage
      // loadingListEvent ||
      // loadingProduct ||
      // loadingEventProduct
    ) {
      return (
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <LoadingComponent />
              </div>
            </div>
          </div>
        </div>
      );
    }

    switch (selectedNode) {
      case -1:
      case 1:
        return (
          <div className="card">
            <div className="card-body">
              <DetailEvent
                event={event}
                onReloadData={(eventId) => getDetailEvent(eventId)}
              />
            </div>
          </div>
        );
      case -2:
      case 2:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt vùng*/}
              <ConfigArea
                eventId={event.id}
                listArea={listArea}
                listAreaSelect={listAreaSelected}
                onReloadData={(eventId) => {
                  getListAreaEvent(eventId);
                }}
              />
            </div>
          </div>
        );
      case 9:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt chỉ tiêu theo vùng*/}
              <TargetArea
                data={targetArea}
                eventId={event.id}
                onReloadData={(eventId) => getListAreaEvent(eventId)}
              />
            </div>
          </div>
        );
      case -5:
      case 5:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt hình*/}
              <ConfigImage
                eventId={event.id}
                data={listImage}
                onReloadData={(eventId) => getImageByEvent(eventId)}
              />
            </div>
          </div>
        );
      case -3:
      case 3:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt kênh*/}
              <ConfigChanel
                eventId={event.id}
                data={listChannel}
                onReloadData={(eventId) => {
                  getChanelByEvent(eventId);
                  getChannelImageByEvent(eventId);
                }}
              />
            </div>
          </div>
        );
      case 4:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt hình theo kênh*/}
              <ImageWithChannel
                eventId={event.id}
                data={listImageChannel}
                listChannel={listChannel}
                onReloadData={(eventId) => getChannelImageByEvent(eventId)}
              />
            </div>
          </div>
        );
      case -4:
      case 6:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt suất*/}
              <ConfigChannelPackage
                eventId={event.id}
                data={listChannelPackage}
                listChannel={listChannel}
                listArea={targetArea}
                onReloadData={(eventId) => {
                  getChannelPackage(eventId);
                  getPackageImageEventId(eventId);
                }}
              />
            </div>
          </div>
        );
      case 7:
        return (
          <div className="card">
            <div className="card-body">
              {/*Cài đặt hình theo suất*/}
              <ConfigChannelPackageImage
                eventId={event.id}
                listChannel={listChannel}
                listImage={listImage}
                listChannelPackage={listChannelPackage}
                data={listImageChannelPackage}
                onReloadData={(eventId) => getPackageImageEventId(eventId)}
              />
            </div>
          </div>
        );
      // case -6:
      // case 8:
      //   return (
      //     <div className="card">
      //       <div className="card-body">
      //         {/* <ImageProduct
      //           eventId={event.id}
      //           listEvent={listEvent}
      //           listImage={listImage}
      //           listProduct={listProduct}
      //           data={dataImageProduct}
      //         /> */}
      //         <ListImageProduct />
      //       </div>
      //     </div>
      //   );
      //<ImageWithChannel />;
      default:
        return null;
    }
  };

  // if(loadingArea){

  // }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="container py-5" style={{ maxWidth: `90%` }}>
          <div className="row">
            <div className="col-md-4">
              <Tree
                value={listDataTree}
                selectionMode="single"
                filter={true}
                onSelectionChange={(e) => setSelectedNode(e.value)}
                style={{ width: "100%" }}
                expandedKeys={expandedKeys}
                selectionKeys={selectedNode}
              />
            </div>
            <div className="col-md-8">{renderBody()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
